export default __webpack_public_path__ + "static/media/260-tile.a26b7ebd.svg";